export class ImperativeModel {
    verb: string;
    affirmativeForms: string[];
    negativeForms: string[];

    constructor(verb: string, affirmativeForms: string[], negativeForms: string[]) {
        this.verb = verb;
        this.affirmativeForms = affirmativeForms;
        this.negativeForms = negativeForms;
    }
}

export class ImperativeIrregularModel {
    infinitive: string;
    imperative: string;
    example: string;

    constructor(infinitive: string, imperative: string, example: string) {
        this.infinitive = infinitive;
        this.imperative = imperative;
        this.example = example;
    }
}
